module.exports = __webpack_public_path__ + "media/images/photos/germany-2ccf7305d1628785e49783ad034ad781.jpg";